import { useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { heroData } from "@/mocks/homeData";

export default function HeroSection() {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const attemptPlay = () => {
      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch(() => {
          // 自動再生ポリシーでブロックされた場合、ユーザーインタラクションを待つ
        });
      }
    };

    // 動画のメタデータ読み込み後に再生を試みる
    video.addEventListener("loadedmetadata", attemptPlay);
    
    // すでに読み込み済みの場合も試みる
    if (video.readyState >= 2) {
      attemptPlay();
    }

    return () => {
      video.removeEventListener("loadedmetadata", attemptPlay);
    };
  }, []);

  return (
    <section className="relative min-h-[600px] md:min-h-[700px] lg:min-h-[800px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <video
          ref={videoRef}
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
          crossOrigin="anonymous"
          className="w-full h-full object-cover object-center"
        >
          <source
            src="https://storage.readdy-site.link/project_files/8401516b-5bec-413c-bb8e-4be730a927e3/943e279d-12c0-442d-8257-182a9a002f57_babe06b9-0158-4a31-a4fb-462172febb8e-1.mp4?v=6f6ca57332da76b4ea9b0036ddd49dfa"
            type="video/mp4"
          />
        </video>
        <div className="absolute inset-0 bg-gradient-to-b from-ocean-900/60 via-ocean-900/45 to-ocean-900/70" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="font-serif text-3xl md:text-5xl lg:text-5xl font-bold leading-tight mb-1">
            <span className="text-white">日本の海から</span>
          </h1>
          <h1 className="font-serif text-4xl md:text-6xl lg:text-7xl font-bold leading-tight mb-8">
            <span className="text-ocean-300">世界の海へ</span>
          </h1>

          <div className="flex justify-center mb-4">
            <img
              src="https://static.wixstatic.com/media/bb3b80_56ac03e9a4d84f7d8caf452336a3c159~mv2.png"
              alt="JPDロゴ"
              className="h-32 md:h-44 w-auto object-contain"
            />
          </div>

          {/* スマホでは2行表示 */}
          <div className="text-white/90 font-medium mb-8 sm:hidden">
            <span className="block text-lg tracking-wider leading-relaxed">
              株式会社
            </span>
            <span className="block text-lg tracking-wider leading-relaxed">
              JAPAN PACIFIC DIVERS
            </span>
          </div>

          {/* タブレット以上は1行表示 */}
          <p className="hidden sm:block text-xl md:text-3xl lg:text-4xl text-white/90 font-medium tracking-widest mb-8">
            株式会社JAPAN PACIFIC DIVERS
          </p>

          <div className="flex items-center justify-center gap-4">
            <Link
              to="/contact"
              className="group inline-flex items-center gap-2 px-8 py-3.5 bg-ocean-500 hover:bg-ocean-400 text-white font-medium rounded-full transition-all whitespace-nowrap"
            >
              見積書依頼
              <i className="ri-file-list-3-line" />
            </Link>
            <Link
              to="/safety"
              className="inline-flex items-center gap-2 px-6 py-3.5 bg-white/15 hover:bg-white/25 backdrop-blur-sm border border-white/30 text-white font-medium rounded-full transition-all whitespace-nowrap"
            >
              <i className="ri-shield-check-line text-ocean-300 text-sm" />
              安全管理体制
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white/50 text-xl" />
      </div>
    </section>
  );
}